/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Pwrdby.QuickMD.Providers.Api
 * OpenAPI spec version: 1.0
 */
import {
  useInfiniteQuery,
  useQuery,
  useSuspenseInfiniteQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ErrorApiOutContract,
  ErrorDescription,
  PatientPackageApiOutContract
} from '../pwrdbyQuickMDProvidersApi.schemas';

import { fetcher } from '@quickmd-llc/frontend-utils';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * # Possible Errors
| HTTP status | ErrorCode           | Description                                              |
|-------------|---------------------|----------------------------------------------------------|
| 404         | PatientNotFound     | The patient with the specified ID could not be found.    |
 * @summary Retrieves every package a patient has bought, newest first, with the balance left on each visit type it
covers.
 */
export const getPatientsPatientIdPackages = (
    patientId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<PatientPackageApiOutContract[]>(
      {url: `https://providers-api.api.quick.md/api/v1/patients/${encodeURIComponent(String(patientId))}/packages`, method: 'GET', signal
    },
      options);
    }
  



export const getGetPatientsPatientIdPackagesInfiniteQueryKey = (patientId?: string,) => {
    return [
    'infinite', `https://providers-api.api.quick.md/api/v1/patients/${patientId}/packages`
    ] as const;
    }

export const getGetPatientsPatientIdPackagesQueryKey = (patientId?: string,) => {
    return [
    `https://providers-api.api.quick.md/api/v1/patients/${patientId}/packages`
    ] as const;
    }

    
export const getGetPatientsPatientIdPackagesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>>, TError = void | ErrorDescription | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdPackagesInfiniteQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>> = ({ signal }) => getPatientsPatientIdPackages(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdPackagesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>>
export type GetPatientsPatientIdPackagesInfiniteQueryError = void | ErrorDescription | ErrorApiOutContract


export function useGetPatientsPatientIdPackagesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdPackages>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdPackages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPackagesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdPackages>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdPackages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPackagesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves every package a patient has bought, newest first, with the balance left on each visit type it
covers.
 */

export function useGetPatientsPatientIdPackagesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdPackagesInfiniteQueryOptions(patientId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Retrieves every package a patient has bought, newest first, with the balance left on each visit type it
covers.
 */
export const prefetchGetPatientsPatientIdPackagesInfiniteQuery = async <TData = Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 queryClient: QueryClient, patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsPatientIdPackagesInfiniteQueryOptions(patientId,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsPatientIdPackagesQueryOptions = <TData = Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError = void | ErrorDescription | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdPackagesQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>> = ({ signal }) => getPatientsPatientIdPackages(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdPackagesQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>>
export type GetPatientsPatientIdPackagesQueryError = void | ErrorDescription | ErrorApiOutContract


export function useGetPatientsPatientIdPackages<TData = Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdPackages>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdPackages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPackages<TData = Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdPackages>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdPackages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPackages<TData = Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves every package a patient has bought, newest first, with the balance left on each visit type it
covers.
 */

export function useGetPatientsPatientIdPackages<TData = Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdPackagesQueryOptions(patientId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Retrieves every package a patient has bought, newest first, with the balance left on each visit type it
covers.
 */
export const prefetchGetPatientsPatientIdPackagesQuery = async <TData = Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 queryClient: QueryClient, patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsPatientIdPackagesQueryOptions(patientId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsPatientIdPackagesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError = void | ErrorDescription | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdPackagesQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>> = ({ signal }) => getPatientsPatientIdPackages(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdPackagesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>>
export type GetPatientsPatientIdPackagesSuspenseQueryError = void | ErrorDescription | ErrorApiOutContract


export function useGetPatientsPatientIdPackagesSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPackagesSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPackagesSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves every package a patient has bought, newest first, with the balance left on each visit type it
covers.
 */

export function useGetPatientsPatientIdPackagesSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdPackagesSuspenseQueryOptions(patientId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetPatientsPatientIdPackagesSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>>, TError = void | ErrorDescription | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdPackagesInfiniteQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>> = ({ signal }) => getPatientsPatientIdPackages(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdPackagesSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>>
export type GetPatientsPatientIdPackagesSuspenseInfiniteQueryError = void | ErrorDescription | ErrorApiOutContract


export function useGetPatientsPatientIdPackagesSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPackagesSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPackagesSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves every package a patient has bought, newest first, with the balance left on each visit type it
covers.
 */

export function useGetPatientsPatientIdPackagesSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdPackagesSuspenseInfiniteQueryOptions(patientId,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




